import { Component, OnInit } from '@angular/core';
import { HttpService } from '../shared/http.service';
import { AlertService } from '../shared/alert.service';
import { TransactionResponse } from '@builtbybros/al-model';
import moment = require('moment');
import { QueryParam } from '../shared/query-param';

@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.scss']
})
export class TransactionComponent implements OnInit {
  entity = 'transaction';
  title = 'Orden de compra';
  transactions = {};
  transactionsReady = false;
  actions = false;
  columns = [
    ['id', 'ID'],
    ['createdAt', 'Fecha'],
    ['user', 'Usuario'],
    ['email', 'Correo'],
    ['pay', 'Pago'],
    ['amount', 'Total'],
    ['delivered', 'Entregado']
  ];
  actionColumns = [
    ['highlight', 'Destacar', false],
    ['edit', 'Editar', false],
    ['delete', 'Eliminar', false]
  ];
  hasDataTables = false;
  prevPath = '/transaction/';
  msg = {
    'deleteSuccess': 'Orden de compra borrada con éxito',
    'deleteError': 'Hubo un error al borrar orden de compra'
  };
  pagination = 10;
  offset = 0;
  filterDelivered = undefined;
  filterPaymentStatus = undefined;
  filterDateFrom = undefined;
  filterDateTo = undefined;
  orderBy = '-createdAt';

  paymentStatus = {
    'pending': 'Pendiente', // The user has not yet completed the payment process
    'approved': 'Aprobado', // The payment has been approved and accredited
    'in_process': 'En Proceso', // Payment is being reviewed
    'in_mediation': 'En disputa', // Users have initiated a dispute
    'rejected': 'Rechazado', // Payment was rejected. The user may retry payment.
    'cancelled': 'Cancelado', // Payment was cancelled by one of the parties or because time for payment has expired
    'refunded': 'Devuelto', // Payment was refunded to the user
    'charged_back': 'Charged Back' // Was made a chargeback in the buyer’s credit card
  };

  constructor(private httpService: HttpService,
              private alertService: AlertService) {
  }

  ngOnInit() {
    this.getTransactions();
  }

  getTransactions() {
    const params = new Array<QueryParam>();
    params.push(new QueryParam('pagination', this.pagination.toString()));
    params.push(new QueryParam('offset', this.offset.toString()));
    params.push(new QueryParam('order', this.orderBy));

    if (this.filterDelivered !== undefined) {
      params.push(new QueryParam('delivered', this.filterDelivered));
    };

    if (this.filterPaymentStatus !== undefined) {
      params.push(new QueryParam('status', this.filterPaymentStatus));
    };

    if (this.filterDateFrom !== undefined) {
      params.push(new QueryParam('dateFrom', this.filterDateFrom));
    };

    if (this.filterDateTo !== undefined) {
      params.push(new QueryParam('dateTo', this.filterDateTo));
    };
    this.httpService.getWithParams('/Transaction/All', params, TransactionResponse.All)
      .subscribe(
        transactionResponse => {
          this.transactions = transactionResponse;
          for (const item of this.transactions['objects']) {
            item['user'] = `${item['customerName']} ${item['customerLastName']}`;
            item['email'] = `${item['customerEmail']}`;
            item['createdAt'] = moment(item['createdAt']).format('DD/MM/YYYY HH:mm');
            item['delivered'] = (item['delivered']) ? 'Si' : 'No';
            item['amount'] = '$ ' + item['amount'];
            item['pay'] = item['pay'] ? this.paymentStatus[item['pay']['status']] : 'No finalizado';
          }
          this.transactionsReady = true;
        }
      );
  }

  setLimit(value) {
    this.pagination = +value;
    this.getTransactions();
  }

  filterByDeliveredStatus(value) {
    this.filterDelivered = value !== '' ? value : undefined;
    this.getTransactions();
  }

  filterByPaymentStatus(value) {
    this.filterPaymentStatus = value !== '' ? value : undefined;
    this.getTransactions();
  }

  filterByDateFrom(value) {
    this.filterDateFrom = value !== '' ? moment(value, 'DD-MM-YYYY').toDate().toISOString() : undefined;
    this.getTransactions();
  }

  filterByDateTo(value) {
    this.filterDateTo = value !== '' ? moment(value, 'DD-MM-YYYY').toDate().toISOString() : undefined;
    this.getTransactions();
  };

  setOffset(value) {
    this.offset = +value;
    this.getTransactions();
  }

}



// WEBPACK FOOTER //
// ./src/app/transaction/transaction.component.ts